import React, { useState } from 'react';
import styled from 'styled-components';
import Edit from '@material-ui/icons/Edit';
import { useSelector } from 'react-redux';
import JurisdictionWebsiteLinkPopup from './JurisdictionWebsiteLinkPopup';
import UrlLink from '../../clientModule/components/Common/Table/UrlLink';
import { RootState } from '../../../redux/root';

const JurisdictionWebsite = ({ setValue, juriWebsitErrorMessage }) => {
  const [show, setShow] = useState<boolean>(false);
  const juri = useSelector((s: RootState) => s.wikiSlice.selectedJurisdiction);
  const caption = 'Jurisdiction Website';
  return (
    <Wrapper>
      {juriWebsitErrorMessage !== '' && <JuriWebsiteError>{juriWebsitErrorMessage}</JuriWebsiteError>}
      <LinkRow>
        {juri.jurisdictionWebsite ? <UrlLink caption={caption} value={juri.jurisdictionWebsite} /> : <LinkPlaceholder>{caption}</LinkPlaceholder>}
        <EditAnchor>
          <EditButton type="button" title="Edit website" onClick={() => setShow(true)}>
            <Edit fontSize="small" />
          </EditButton>
          <JurisdictionWebsiteLinkPopup show={show} setShow={setShow} setValue={setValue} />
        </EditAnchor>
      </LinkRow>
    </Wrapper>
  );
};

export default JurisdictionWebsite;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40px;
  position: relative;
`;

const LinkRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const LinkPlaceholder = styled.div`
  font-size: 0.875rem;
  color: var(--mainText);
`;

const EditAnchor = styled.div`
  position: relative;
  display: inline-flex;
`;

const EditButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--neutral-0);
  color: var(--neutral-500);
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: var(--primary-50);
    border-color: var(--primary-300);
    color: var(--primary-600);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;

const JuriWebsiteError = styled.div`
  color: var(--danger-500);
  font-size: 0.75rem;
  position: absolute;
  top: -16px;
  left: 0;
`;
